import { useState, useEffect } from "react";

/**
 * DK : Navigacja do wybierania zakładek
 * @param items Tablica elementów do wybrania 
 * @param defaultItem Domyślnie wybrany item
 * @param onClick Funkcja wywołana po zmianie elementu (zwraca nazwe wybranego elementu)
 * @param isFullWidth Czy rozciągać zakładki na pełną długośc diva?
 * @returns 
 */
const CustomNavItem = ({ items, defaultItem, onClick, isFullWidth }) => {
    const [selectedItem, setSelectedItem] = useState(defaultItem)

    let navStyle = isFullWidth ? 'product-nav-fullscreen' : 'product-nav'
    let navItemStyle = isFullWidth ? 'product-nav-fullscreen-item' : 'product-nav-item'
    let navItemSelectedStyle = isFullWidth ? 'product-nav-fullscreen-item-selected' : 'product-nav-item-selected'

    useEffect(() => {
        setSelectedItem(defaultItem)
    }, [defaultItem])

    const getStyle = (navItem) => {
        return navItem === selectedItem ? `${navItemStyle} ${navItemSelectedStyle}` : `${navItemStyle}`
    }
    const handleClick = (navItem) => {
        setSelectedItem(navItem)
        if (onClick) {
            onClick(navItem)
        }
    }

    return (
        <div className={navStyle}>
            {items.map((item, key) => (
                <span
                    key={key}
                    className={getStyle(item)}
                    onClick={() => handleClick(item)}
                >
                    {item}
                </span>
            ))}
        </div>
    )
}

export default CustomNavItem